import React from 'react';
import Button from '@mui/material/Button';

const MDButton = React.forwardRef((props, ref) => {
  return <Button ref={ref} {...props}>{props.children}</Button>;
});

export default MDButton;